import React from "react";
import menuData from "../assets/menu.json";

function MenuPage() {
  const menu = menuData.menu; // Accede al objeto 'menu' dentro del JSON

  return (
    <div>
      <section className="content-section">
        <h1>Menú</h1>
        <p>
          Nuestra carta ofrece una cuidada selección de bebidas, cócteles y
          aperitivos.
        </p>
        {Object.keys(menu).map((category) => (
          <div key={category} style={{ marginBottom: "20px" }}>
            <h2 style={{ textTransform: "capitalize" }}>{category}</h2>
            <ul
              style={{
                textAlign: "left",
                margin: "20px auto",
                maxWidth: "400px",
                lineHeight: "1.8",
              }}
            >
              {menu[category].map((item, index) => (
                <li key={index}>
                  <strong>{item.nombre}</strong> -{" "}
                  {item.descripcion || "Descripción no disponible"}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </section>
    </div>
  );
}

export default MenuPage;
